import { FormGroup } from '@angular/forms';
import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { NINETEEN_HUNDRED } from '@core/helpers/constants';
import { addRemoveError, getControl } from '@shared/helpers/form.helper';
import { toNum } from '@shared/helpers/math.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { REQUIRED_STATUS } from '@shared/constants/shared.constants';
import { isEqual } from 'lodash-es';
import { formPaths } from '@shared/constants/form-paths.const';
import { getScopoSocialeControl } from './helpers/scopo-sociale-form-validators.helper';

export const scopoSocialeRules: FormGroupRules = {
    my_RicaviEccAnno2: (form: FormGroup) => {
        ricavoCostiEccAnnoHelper(form, 'my_RicaviEccAnno2', 'my_BilAnno2');
    },

    my_RicaviEccAnno1: (form: FormGroup) => {
        ricavoCostiEccAnnoHelper(form, 'my_RicaviEccAnno1', 'my_BilAnno1');
    },

    my_CostiEccAnno2: (form: FormGroup) => {
        ricavoCostiEccAnnoHelper(form, 'my_CostiEccAnno2', 'my_BilAnno2');
    },

    my_CostiEccAnno1: (form: FormGroup) => {
        ricavoCostiEccAnnoHelper(form, 'my_CostiEccAnno1', 'my_BilAnno1');
    },

    my_RicaviVendDep: (form: FormGroup) => {
        const control = getScopoSocialeControl(form, 'my_RicaviVendDep');
        const my_RicaviVend: string = getScopoSocialeControl(form, 'my_RicaviVend')?.value;
        const errors = control.errors ?? {};

        addRemoveError(isNilOrEmpty(my_RicaviVend) && isNilOrEmpty(control?.value), errors, 'my_RicaviVendDep', {
            status: 'Attenzione! Ricavi vendite non presenti.',
        });

        control.setErrors(isEqual(errors, {}) ? null : errors);
    },
};

const ricavoCostiEccAnnoHelper = (form: FormGroup, fieldName: string, bilAnnoField: string): void => {
    const control = getScopoSocialeControl(form, fieldName);
    const bilAnno = toNum(getControl(form, `${formPaths.datiBilancio}.${bilAnnoField}`)?.value);
    const errors = control.errors ?? {};

    addRemoveError(isNilOrEmpty(control?.value) && bilAnno > NINETEEN_HUNDRED, errors, fieldName, {
        status: REQUIRED_STATUS,
    });

    control.setErrors(isEqual(errors, {}) ? null : errors);
};
